import React, { useLayoutEffect } from 'react';
const activeDescendantClass = 'webchat__basic-transcript__activity-active-descendant';
const isAndroid = /Linux; Android/u.test(navigator.userAgent);
const androidAutoScrollBugMiddleware = () => (next) => (...args) => {
    const render = next(...args);
    if (!isAndroid || typeof render !== 'function') {
        return render;
    }
    else {
        return (...children) => {
            useLayoutEffect(() => {
                document.querySelectorAll('article').forEach((el) => {
                    const firstChild = el.firstChild;
                    if (firstChild !== null && firstChild.className.includes(activeDescendantClass)) {
                        return;
                    }
                    const activeDescendant = document.createElement('DIV');
                    activeDescendant.className = activeDescendantClass;
                    el.prepend(activeDescendant);
                });
            }, []);
            return React.createElement(React.Fragment, null, render(...children));
        };
    }
};
export { androidAutoScrollBugMiddleware };
//# sourceMappingURL=androidAutoScrollBugMiddleware.js.map